import { BareActionContext } from 'vuex-typex'
import { ConvoState } from '../state'
import { RootState } from '../..'
import setConvoQuery from './set-convo-query'

export default async function toggleFollowedByMe(context: BareActionContext<ConvoState, RootState>)
{
  setConvoQuery(context)

  return
}
